import React, { useState } from "react";
import {
  Alert,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Table,
  Spinner,
  Col,
  Row,
  Form,
} from "react-bootstrap";
import {
  generarEnlace,
  getSendData,
  sendSurveyEmployee,
} from "../../redux/climalaboral/campaña/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import toastr from "toastr";
import { Typeahead } from "react-bootstrap-typeahead";

const renderData = (data) => {
  let dataOpt = [];
  data
    .sort((a, b) => {
      if (a.nombre && b.nombre) {
        if (a.nombre.toLowerCase() === b.nombre.toLowerCase()) {
          return 0;
        }
        if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
          return -1;
        }
      }
      return 1;
    })
    .map((user) => {
      dataOpt = [
        ...dataOpt,
        {
          id: user.id,
          username: user.codigo,
          label: `${user.codigo} / ${user.nombre.toUpperCase()}`,
        },
      ];
    });
  return dataOpt;
};

const ShowSendNotif = (props) => {
  const [showModalSend, setShowModalSend] = useState(false);
  const [showModalNotSend, setShowModalNotSend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enlaceLoading, setEnlaceLoading] = useState(false);
  const [loadingSendSurvey, setLoadingSendSurvey] = useState(false);
  const [_index, setIndex] = useState(false);
  const [enlace, setEnlace] = useState("");
  const [data, setData] = useState(false);
  const [error, setError] = useState("");
  const [showModalEnlace, setShowModalEnlace] = useState(false);
  const [userSelect, setUserSelect] = useState("");
  const [isUserValid, setIsUserValid] = useState(false);

  const dispatch = useDispatch();

  const onViewModalEnlace = () => {
    dispatch(
      getSendData(
        {
          campania_segmento_id: props.item.id,
        },
        setData,
        setLoading,
        setError
      )
    );
    setIsUserValid(false);
    setUserSelect("");
    setEnlace("");
    setShowModalEnlace(true);
  };

  const onGenerarEnlace = () => {
    try {
      if (userSelect.length === 0) {
        setIsUserValid(true);
        return;
      } else {
        setIsUserValid(false);
      }
      const req = {
        username: userSelect[0].username,
        campania_id: props.item.campania,
        campania_segmento: props.item.id,
      };
      dispatch(generarEnlace(req, setEnlace, setEnlaceLoading));
    } catch (error) {
      toastr.error("Error al generar el enlace:", error);
    }
  };

  const copyToClipboard = (textToCopy) => {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  return (
    <>
      <OverlayTrigger
        placement="auto"
        overlay={<Tooltip {...props}>No enviadas</Tooltip>}
      >
        <Button
          size="sm"
          variant="link"
          type="button"
          className="text-warning"
          onClick={() => {
            dispatch(
              getSendData(
                {
                  campania_segmento_id: props.item.id,
                },
                setData,
                setLoading,
                setError
              )
            );
            setShowModalNotSend(true);
          }}
        >
          <i className="material-icons">error</i>
        </Button>
      </OverlayTrigger>
      <OverlayTrigger
        placement="auto"
        overlay={<Tooltip {...props}>Enviadas</Tooltip>}
      >
        <Button
          size="sm"
          variant="link"
          type="button"
          className="text-success"
          onClick={() => {
            dispatch(
              getSendData(
                {
                  campania_segmento_id: props.item.id,
                },
                setData,
                setLoading,
                setError
              )
            );
            setShowModalSend(true);
          }}
        >
          <i className="material-icons">mark_email_read</i>
        </Button>
      </OverlayTrigger>
      <OverlayTrigger
        placement="left"
        overlay={<Tooltip {...props}>Generar enlace de la encuesta</Tooltip>}
      >
        <Button
          size="sm"
          variant="link"
          type="button"
          style={{ color: "#141E30" }}
          onClick={() => onViewModalEnlace()}
        >
          <i className="material-icons">link</i>
        </Button>
      </OverlayTrigger>
      <Modal
        show={showModalNotSend}
        onHide={() => {
          setShowModalNotSend(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Encuestas no enviadas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data && data.empleados_sin_encuesta.length > 0 ? (
            <Table striped hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Colaborador</th>
                  <th>Código</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.empleados_sin_encuesta.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.nombre}</td>
                    <td>{item.codigo}</td>
                    <td>
                      <OverlayTrigger
                        placement="left"
                        overlay={
                          <Tooltip
                            style={{ zIndex: "9999999999999" }}
                            {...props}
                          >
                            Enviar encuesta
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          variant="link"
                          type="button"
                          style={{ color: "#141E30" }}
                          onClick={() => {
                            setIndex(index);
                            dispatch(
                              sendSurveyEmployee(
                                {
                                  campania_segmento_id: props.item.id,
                                  colaborador: item.codigo,
                                },
                                data,
                                setData,
                                index,
                                setLoadingSendSurvey
                              )
                            );
                          }}
                        >
                          {parseInt(_index) === parseInt(index) &&
                          loadingSendSurvey ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                                size="sm"
                              />
                            </div>
                          ) : (
                            <i className="material-icons">forward_to_inbox</i>
                          )}
                        </Button>
                      </OverlayTrigger>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <>
              {!!error ? (
                <Alert variant="danger" className="mt-1 mb-3">
                  {error}
                </Alert>
              ) : (
                <Alert variant="info" className="mt-1 mb-3">
                  No hay Colaborador sin encuesta
                </Alert>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={() => setShowModalNotSend(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModalSend}
        onHide={() => {
          setShowModalSend(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Encuestas enviadas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data && data.empleado_con_encuesta.length > 0 ? (
            <Table striped hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Colaborador</th>
                  <th>Código</th>
                </tr>
              </thead>
              <tbody>
                {data.empleado_con_encuesta.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.nombre}</td>
                    <td>{item.codigo}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <>
              {!!error ? (
                <Alert variant="danger" className="mt-1 mb-3">
                  {error}
                </Alert>
              ) : (
                <Alert variant="info" className="mt-1 mb-3">
                  No hay Colaborador con encuesta
                </Alert>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={() => setShowModalSend(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalEnlace} onHide={() => setShowModalEnlace(false)}>
        {/* <Form onSubmit={onGenerarEnlace} noValidate validated={validated}> */}
        <Modal.Header closeButton>
          <Modal.Title>Generar enlace</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.item.campania_list &&
            props.item.campania_list.fecha_inicio &&
            moment(props.item.campania_list.fecha_inicio).diff(
              moment(moment().format("YYYY-MM-DD")),
              "days"
            ) === 1 && (
              <Alert variant="danger" className="mt-1 mb-1">
                No se puede generar enlace porque la campaña aún no comienza.
              </Alert>
            )}
          {props.item.campania_list &&
            props.item.campania_list.fecha_fin &&
            moment(props.item.campania_list.fecha_fin).diff(
              moment(moment().format("YYYY-MM-DD")),
              "days"
            ) === -1 && (
              <Alert variant="danger" className="mt-1 mb-1">
                No se puede generar enlace porque la campaña ya finalizó.
              </Alert>
            )}
          {!loading && data && data.personas_enlace.length === 0 && (
            <Alert variant="danger" className="mt-1 mb-1">
              No se ha enviado la campaña a ningun empleado.
            </Alert>
          )}
          <Form.Group as={Row} className="align-items-center">
            <Form.Label column sm="12" md="12">
              <b>Usuarios:</b>
            </Form.Label>
            <Col sm={loading ? 10 : 12}>
              <Typeahead
                isInvalid={isUserValid}
                placeholder="Seleccione un usuario"
                options={data ? renderData(data.personas_enlace) : []}
                onChange={(selected) => setUserSelect(selected)}
                disabled={
                  loading ||
                  (props.item.campania_list &&
                    moment(props.item.campania_list.fecha_inicio).diff(
                      moment(moment().format("YYYY-MM-DD")),
                      "days"
                    ) === 1) ||
                  (props.item.campania_list &&
                    moment(props.item.campania_list.fecha_fin).diff(
                      moment(moment().format("YYYY-MM-DD")),
                      "days"
                    ) === -1) ||
                  (data && data.personas_enlace.length === 0)
                }
                selected={userSelect}
              ></Typeahead>
            </Col>
            {loading && (
              <Col sm={1}>
                <Spinner animation="border" size="sm" />
              </Col>
            )}
          </Form.Group>
          <Col>
            <Row className="pl-1">
              <p>
                <b>Enlace generado:</b>
              </p>
            </Row>
            <Row className="mt-1 d-flex flex-wrap justify-content-between align-items-center">
              {enlaceLoading ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : (
                <>
                  <Col
                    className="px-3 py-2 rounded-pill"
                    style={{
                      border: "1px solid rgb(235, 237, 240)",
                      height: "2.5rem",
                    }}
                  >
                    <span>
                      {enlace && enlace !== "" ? (
                        enlace
                      ) : (
                        <div className="pt-3"></div>
                      )}
                    </span>
                  </Col>
                  <Col md="2">
                    <Button
                      size="sm"
                      variant="link"
                      type="button"
                      className="rounded-circle"
                      style={{ color: "#141E30" }}
                      disabled={
                        enlace === "" ||
                        (props.item.campania_list &&
                          moment(props.item.campania_list.fecha_inicio).diff(
                            moment(moment().format("YYYY-MM-DD")),
                            "days"
                          ) === 1) ||
                        (props.item.campania_list &&
                          moment(props.item.campania_list.fecha_fin).diff(
                            moment(moment().format("YYYY-MM-DD")),
                            "days"
                          ) === -1) ||
                        (data && data.personas_enlace.length === 0)
                      }
                      onClick={() => {
                        copyToClipboard(enlace)
                          .then(() =>
                            toastr.success(
                              "Enlace copiado al portapapeles",
                              "",
                              {
                                progressBar: true,
                                rtl: true,
                              }
                            )
                          )
                          .catch(() =>
                            toastr.error("Algo salio mal :(", "", {
                              progressBar: true,
                              rtl: true,
                            })
                          );
                      }}
                    >
                      <i className="material-icons">content_copy</i>
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={() => setShowModalEnlace(false)}
          >
            Cerrar
          </Button>
          <Button
            onClick={onGenerarEnlace}
            className="rounded-pill"
            disabled={
              userSelect === "" ||
              (props.item.campania_list &&
                moment(props.item.campania_list.fecha_inicio).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 1) ||
              (props.item.campania_list &&
                moment(props.item.campania_list.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === -1) ||
              (data && data.personas_enlace.length === 0)
            }
            variant="info"
            type="button"
          >
            Generar
          </Button>
        </Modal.Footer>
        {/* </Form> */}
      </Modal>
    </>
  );
};

export default ShowSendNotif;
